var exports = {
  "kL": "ChannelInvitesTab.module__container___ejFvMi",
  "wx": "ChannelInvitesTab.module__header___ejFvMi",
  "h_": "ChannelInvitesTab.module__description___ejFvMi",
  "GC": "ChannelInvitesTab.module__buttonGroup___ejFvMi",
  "dc": "ChannelInvitesTab.module__spinnerContainer___ejFvMi",
  "sJ": "ChannelInvitesTab.module__invitesContainer___ejFvMi",
  "$h": "ChannelInvitesTab.module__invitesList___ejFvMi",
  "eu": "ChannelInvitesTab.module__inviteItems___ejFvMi",
};

module.exports = exports;
